import React, { useEffect, useState } from 'react';
import OwnDomainPanel from './OwnDomainPanel';
import { SoftField, SoftText } from './ui';

/**
 * FROM (the page's own address on Portal's sending domain, read-only) and REPLIES GO TO — a page
 * setting, saved on blur, shared by all its emails. Blank = the owner's account email.
 */
export default function SendingFrom({ client, readOnly }) {
  const [s, setS] = useState(null);
  const [reply, setReply] = useState('');
  const [state, setState] = useState(null);
  useEffect(() => {
    let live = true;
    client.getEmailSettings().then((r) => { if (live && r?.success) { setS(r.data); setReply(r.data.replyTo || ''); } });
    return () => { live = false; };
  }, [client]);
  if (!s) return null;
  const commit = async () => {
    if ((reply || '') === (s.replyTo || '')) return;
    setState('saving');
    const r = await client.saveEmailSettings({ replyTo: reply.trim() || null });
    if (r?.success) { setS(r.data); setReply(r.data.replyTo || ''); setState('saved'); } else setState(r?.message || r?.error || 'Could not save.');
  };
  return (
    <div className="grid" style={{ gridTemplateColumns: 'repeat(auto-fit, minmax(220px, 1fr))', gap: 14 }} data-testid="sending-from">
      <SoftField label="SENDS FROM"><SoftText value={s.from} readOnly /></SoftField>
      <SoftField label="REPLIES GO TO" right={state === 'saving' ? 'SAVING…' : state === 'saved' ? 'SAVED' : state ? '' : 'BLANK = YOUR EMAIL'} rightColor={state && state !== 'saving' && state !== 'saved' ? '#EF4444' : '#9CA3AF'}>
        {readOnly ? <SoftText value={s.replyTo || s.defaultReplyTo} readOnly /> : (
          <input value={reply} onChange={(e) => { setReply(e.target.value); setState(null); }} onBlur={commit} placeholder={s.defaultReplyTo || 'you@example.com'} aria-label="Replies go to" type="email"
            className="w-full rounded-[14px] border-2 border-transparent bg-[#F5F5F5] font-mono text-[13px] outline-none focus:border-black focus:bg-white" style={{ height: 46, padding: '0 16px' }} />
        )}
        {state && state !== 'saving' && state !== 'saved' && <span style={{ fontSize: 10, color: '#EF4444' }}>{state}</span>}
      </SoftField>
      {client.connectDomain && (
        <div style={{ gridColumn: '1 / -1' }}>
          <OwnDomainPanel client={client} domain={s.domain} readOnly={readOnly} fallbackFrom={fallbackOf(s)}
            onChange={async () => { const r = await client.getEmailSettings(); if (r?.success) setS(r.data); }} />
        </div>
      )}
    </div>
  );
}

/** Where page email goes out from when its own domain isn't live: the page's address on Portal's sending domain. */
const fallbackOf = (s) => (s.domain && s.domain.status === 'verified' ? 'your page’s Portal address' : s.from);
